import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=e3b8cb48&scoped=true&"
import script from "./agreement.vue?vue&type=script&lang=js&"
export * from "./agreement.vue?vue&type=script&lang=js&"
import style0 from "./agreement.vue?vue&type=style&index=0&id=e3b8cb48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b8cb48",
  null
  
)

export default component.exports